import { format } from "date-fns";

export const numberFormatter = (number) => {
  const numberFormatterInstance = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  return `$${numberFormatterInstance.format(number)}`;
};

export const dateFormatter = (date) => {
  date = new Date(date);
  return format(date, "MM/dd/yyyy");
};

export const EMPTY_VALUE = "—";

const ISO_DATE = /^(\d{4})-(\d{2})-(\d{2})/;

// The backend sends `false` for every field it has no value for
export const isBlank = (value) =>
  value === false || value === null || value === undefined || value === "";

// Odoo dates arrive as plain "YYYY-MM-DD" strings. Building the date in local
// time keeps the day from shifting for users behind UTC.
export const parseDate = (value) => {
  if (isBlank(value)) {
    return null;
  }

  const parts = ISO_DATE.exec(String(value));
  if (!parts) {
    return null;
  }

  return new Date(+parts[1], +parts[2] - 1, +parts[3]);
};

export const shortDate = (value, locale = "es") => {
  const date = parseDate(value);
  if (!date) {
    return isBlank(value) ? EMPTY_VALUE : String(value);
  }

  return new Intl.DateTimeFormat(locale, {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(date);
};

// Whole days from today to `value`: negative when the date is in the past
export const daysFromToday = (value) => {
  const date = parseDate(value);
  if (!date) {
    return null;
  }

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return Math.round((date - today) / 86400000);
};

// Odoo many2one fields arrive as [id, label] (or `false` when unset)
export const relationLabel = (value) => {
  if (Array.isArray(value)) {
    return value[1] || EMPTY_VALUE;
  }

  return isBlank(value) ? EMPTY_VALUE : String(value);
};

export const capitalize = (string) => {
  return string
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};
